import { render, staticRenderFns } from "./AddTenderForm.vue?vue&type=template&id=18bae9d8&scoped=true"
import script from "./AddTenderForm.vue?vue&type=script&lang=js"
export * from "./AddTenderForm.vue?vue&type=script&lang=js"
import style0 from "./AddTenderForm.vue?vue&type=style&index=0&id=18bae9d8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bae9d8",
  null
  
)

export default component.exports